
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import { ActionTypes, INotification } from "@/modules/ui/store/types";
import VIcon from "@/common/components/VIcon.vue";
import IconButton from "@/common/components/IconButton.vue";

// const COLORS = {
//   success: 'text-toast-successText',
//   error: ''
// }
export default defineComponent({
  components: { VIcon, IconButton },
  name: "NotificationItem",
  props: {
    notification: {
      type: Object as () => INotification,
    },
  },
  data() {
    return {
      timeout: null as any,
    };
  },
  computed: {
    containerType() {
      switch (this.notification?.type) {
        case "error":
          return "border-toast-errorColor bg-toast-errorBackground";
        case "success":
          return "border-toast-successColor bg-toast-successBackground";
        default:
          break;
      }
      return "";
    },
    color() {
      switch (this.notification?.type) {
        case "error":
          return "text-toast-errorText";
        case "success":
          return "text-toast-successText";
        default:
          break;
      }
      return "";
    },
    iconName() {
      switch (this.notification?.type) {
        case "success":
          return "tick";
      }
      return "";
    },
  },
  methods: {
    ...mapActions("ui", [ActionTypes.REMOVE_NOTIFICATION]),
    onClose() {
      this.removeNotication(this.notification?.id);
    },
  },
  created() {
    this.timeout = setTimeout(() => {
      this.removeNotication(this.notification?.id);
    }, 3000);
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
});
